import { render, staticRenderFns } from "./GeneralAdvice.vue?vue&type=template&id=02a9b468&"
import script from "./GeneralAdvice.vue?vue&type=script&lang=js&"
export * from "./GeneralAdvice.vue?vue&type=script&lang=js&"
import style0 from "./GeneralAdvice.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports